// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"07e037cd","381":"449bb0a9","387":"34c99715","451":"37f68f70","882":"5108e179","893":"9561e3f9"}[chunkId] + ".chunk.js";
};